//var lastScrollTop = 0;
   var shorterHeaderHeight = window.innerHeight;
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
   //Mobile do nothing 
  }else{
    shorterHeaderHeight = shorterHeaderHeight - 150;
  }
  
  //$(".main-page-banner").css("height", window.innerHeight + "px");
  $(".main-page-banner").css("height", shorterHeaderHeight + "px");
  if ($(".main-page-banner .parallax-bg").length > 0)
  {
    $(".main-page-banner .parallax-bg").css("height", shorterHeaderHeight + "px");
  }
    jQuery(window).on('scroll', function() {
      if (typeof jQuery(".menu-drawer-container").attr("open") === "undefined")
      {
        $(".main-header.sticky").removeClass("nav-open");
      }

      if (window.scrollY <= 0)
      {
        $(".main-header").removeClass("sticky");
        if ($(".theiaStickySidebar").length > 0)
        {
          $(".theiaStickySidebar").css({"transform":"none", "position":"static"});
        }
      }

      
      var balzacsInfographic = $("section.balzacs-infographic");
      if (balzacsInfographic.length > 0)
      {
        var outlineSvg = $("#sustainability-outline");
        let windowHeight = window.innerHeight;
        let outlineSvgTop = outlineSvg.offset().top;  
        let scrollAnchor = outlineSvgTop - (windowHeight * (5/8));

        if (window.scrollY > scrollAnchor)
        {
          outlineSvg.find(".path").addClass("scrolled");
          balzacsInfographic.find(".mask:not(.mask-right-lg)").addClass("scrolled");
        }

        var recipeRight = $(".recipe__right");
        let recipeRightTop = recipeRight.offset().top;  
        scrollAnchor = recipeRightTop - (windowHeight * (6/7));
        if (window.scrollY > scrollAnchor)
        {
          recipeRight.find(".mask-right-lg").addClass("scrolled");
        }
      }

      if ($(".main-page-banner .parallax-bg").length > 0)
      {
        $(".main-page-banner .parallax-bg").css("transform", "translateY(-" + (window.scrollY / 2) + "px)");
      }
    });

jQuery("#header-nav-tag").click(function()
{
  jQuery(".main-header").toggleClass("nav-open");
  
});